import { render, staticRenderFns } from "./smartHomeBox.vue?vue&type=template&id=4cf62a34&scoped=true&"
import script from "./smartHomeBox.vue?vue&type=script&lang=js&"
export * from "./smartHomeBox.vue?vue&type=script&lang=js&"
import style0 from "./smartHomeBox.vue?vue&type=style&index=0&id=4cf62a34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf62a34",
  null
  
)

export default component.exports